export default "__VITE_ASSET__DNDPUP5L__"